module.exports = __webpack_public_path__ + "img/p4-bg.5f7be5dc.png";